
import { clearOrganisationChangeReloads, sessionCookieFetch } from './dag-sync/organisation-change';
import { sessionChangeFailed, sessionChangeRefused } from './session-change-refusal';
/**
 * SWITCH TO THE ORGANISATION A RECORD IS IN (Tom, 2026-10-20: "Before since
 * you keep asking"): what a page refused as `other_organisation` offers.
 * The session is bound to that organisation (POST /auth/active-organisation,
 * the same switch the profile page makes), then the page reloads, so
 * everything it holds is read again as the new organisation and the record
 * opens. Answers false when the server would not switch: its refusal is
 * said at the top of the page (session-change-refusal.ts), and a
 * `session_moved_on` reloads the page once.
 */
const SERVER = process.env.NEXT_PUBLIC_SOURCEPILOT_URL || "";

export async function switchOrganisation(organisationId: string, reload: () => void = () => window.location.reload()): Promise<boolean> {
  try {
    const r = await sessionCookieFetch(`${SERVER}/auth/active-organisation`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ organisation_id: organisationId }),
    });
    if (!r.ok) {
      await sessionChangeRefused(r, "The organisation was not switched.", reload);
      return false;
    }
  } catch (e) {
    sessionChangeFailed(e, "The organisation was not switched.");
    return false;
  }
  // everything this page holds was read as the old organisation; the
  // session is the switch's now, so a 4005 count before it is over
  clearOrganisationChangeReloads();
  reload();
  return true;
}
